// dependencies
import { Map } from "immutable";

const initialState = Map({
	selectionMaps: Map(),
	selectionObjects: Map(),
	selectionObjectCounts: Map(),
});

export default function selections(state = initialState, action) {
	switch (action.type) {
		case "SELECTIONS:TOGGLE_USER": {
			return state.withMutations((mutable) => {
				action.userIds.forEach((userId) => {
					const currentState = state.getIn(["selectionMaps", action.selectionObjectId, userId], false);
					const nextState = !(currentState === true || currentState === "spinning-to-unchecked");

					mutable.setIn(["selectionMaps", action.selectionObjectId, userId], nextState);
				});
			});
		}

		case "SELECTIONS:TOGGLE_SPINNER": {
			return state.withMutations((mutable) => {
				action.userIds.forEach((userId) => {
					const currentState = state.getIn(["selectionMaps", action.selectionObjectId, userId], false);
					const nextState = currentState === true ? "spinning-to-unchecked" : "spinning-to-checked";

					mutable.setIn(["selectionMaps", action.selectionObjectId, userId], nextState);
				});
			});
		}

		case "SELECTIONS:UPDATE_SELECTION": {
			return state.setIn(["selectionMaps", action.selectionObjectId], action.selectedUsersMap);
		}

		case "SELECTIONS:PARSE_GET": {
			return state.setIn(["selectionObjects", action.selectionObjectId], action.object);
		}

		case "SELECTIONOBJECT:COUNT@SUCCESS": {
			return state.setIn(["selectionObjectCounts", action.request.props.id], action.response.get("count"));
		}

		case "SELECTIONS:COUNT@SUCCESS": {
			return state.setIn(["selectionObjectCounts", action.selectionId], action.response.data.count);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
